export const Busy: React.FC<any> = ({ busyMessage }) => {
  return (
    <div className="z-20 fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white p-4 rounded-md shadow-md">
        <div className="flex justify-center items-center">
          <svg
            className="animate-spin h-5 w-5 text-indigo-500 mr-3"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A8.001 8.001 0 0112 4V0C6.486 0 2 4.486 2 10h4v7.291z"
            ></path>
          </svg>
          <span>{busyMessage}</span>
        </div>
      </div>
    </div>
  );
};
